import i18n from 'infrastructure/i18n';
import { fullNamePresenter } from 'utils';
import { formatRoleName } from 'utils/formatters';
import { tableSortMap } from 'infrastructure/antd/functions/create-sort-order';

import type { TCareManagersFilter } from 'infrastructure/hooks/agency-doctor';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';
import type { TCareManager } from 'infrastructure/interfaces';

export const useCareManagersColumns = ({
  filter,
}: {
  filter: TCareManagersFilter;
}): {
  columns: IBaseTableColumns<TCareManager>;
} => {
  return {
    columns: [
      {
        label: i18n.t('labels.assignedPatients'),
        key: 'patientCount',
        sortable: true,
        sortKey: 'patientCount',
        width: '5px',
        align: 'center',
        sortOrder:
          filter.sortBy === 'patientCount'
            ? tableSortMap[filter.sortDirection ?? '']
            : undefined,
        render: (_, { patientCount }) => patientCount,
      },
      {
        label: i18n.t('labels.careManager'),
        key: 'firstName',
        width: '100px',
        sortable: true,
        sortKey: 'fullName',
        sortOrder:
          filter.sortBy === 'name'
            ? tableSortMap[filter.sortDirection ?? '']
            : undefined,
        render: (firstName: string, { lastName }) =>
          fullNamePresenter({ firstName, lastName }),
      },
      {
        label: i18n.t('labels.role'),
        key: 'roles',
        width: '220px',
        render: (_, { roles }) =>
          roles?.map((r) => formatRoleName(r.name)).join(', '),
      },
    ],
  };
};
